export default class User {
    static getData({id, name}) {
        return JSON.stringify({
            id,
            name,
        })
    }
}
